import script from "./DepartmentEmployeesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentEmployeesTab.vue?vue&type=script&setup=true&lang=js"

import "./DepartmentEmployeesTab.vue?vue&type=style&index=0&id=120bf090&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-120bf090"]])

export default __exports__